import { render, staticRenderFns } from "./BeneficioView.vue?vue&type=template&id=f14d8a40&scoped=true&"
import script from "./BeneficioView.vue?vue&type=script&lang=ts&"
export * from "./BeneficioView.vue?vue&type=script&lang=ts&"
import style0 from "./BeneficioView.vue?vue&type=style&index=0&id=f14d8a40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14d8a40",
  null
  
)

export default component.exports